import {requestLogin, useIsAuthenticated} from "@/entities/session";
import {User} from "@/entities/user";
import {Link} from "@/shared/ui/Link";
import {Svg} from "@/shared/ui/Svg";
import styles from "../HeaderMain/HeaderMain.module.scss";

type Props = {
    user: User;
}

export const ProfileIcon = (
    {
        user
    }: Props
) => {
    const isAuthenticated = useIsAuthenticated();

    const activeOrders = user.ordersCount + user.refundsCount;

    const content = (
        <>
            <Svg id={`profile`} className={styles.profileIcon} />
            {activeOrders > 0 && (<span className={styles.profileIconDot} />)}
        </>
    );

    if (isAuthenticated) {
        return (
            <Link href={`/home?profile=profile`} className={styles.profileIconContainer}>
                {content}
            </Link>
        );
    }

    return (
        <button type={`button`} onClick={requestLogin} className={styles.profileIconContainer}>
            {content}
        </button>
    );

    // return (
    //     <Button variant={`icon`} onClick={openModal} className={styles.profileIconContainer}>
    //         {content}
    //     </Button>
    // );
}
